<template>
	<div class="dynvibeBox">
		<div class="col-lg-12 dynvibeTitleBox">
			<h2>Moodboard</h2>
		</div>
		<div class="col-lg-12">
			<div>
				<input type="radio" value="moodboard" v-model="view" name="moodboard" id="moodboard" />
				<label for="moodboard"><span>Moodboard view</span></label>
				<input type="radio" value="posts" v-model="view" name="posts" id="posts" />
				<label for="posts"><span>Posts view</span></label>
			</div>
			<div v-if="view == 'moodboard'" class="col-xs-9">
				<select v-model="nbPhotos" class="form-control dynvibeSelect" @change="changeNbPhotos()">
					<option value="10">10</option>
					<option value="20">20</option>
					<option value="30">30</option>
					<option value="50">50</option>
				</select>
			</div>
			<div v-if="view == 'posts'">
				<div v-if="posts.length != 0" class="row dynvibePagination">
					<div class="col-lg-12">
						<div style="float: right; margin-top: 10px">
							<pagination
								v-if="requests.page >= 0"
								:page="requests.page"
								:page-max="requests.pageMax"
								@changepage="changePostPage($event)"
							></pagination>
						</div>
					</div>
				</div>
				<div class="col-lg-12 profileListPosts dynvibeListPosts">
					<div v-if="posts.length === 0" class="noData"><p>No Data to display</p></div>
					<div v-else>
						<div v-for="post in posts" :key="post._id">
							<div class="row dynvibePostLine">
								<div class="dynvibeStoryImg">
									<span v-if="post.post_picture"
										><a :href="post.post_url" target="_blank" :style="postImage(post)"></a
									></span>
									<span v-else style="width: 60px; height: 60px; margin-left: 10px; margin-top: 12px"></span>
								</div>
								<div class="dynvibeStoryContenu">
									<div class="row dynvibeStoryInfo">
										<div style="max-width: 50%">
											<span class="dynvibeStoryInfoDate" style="width: unset">{{ getPostDate(post.post_date) }}</span>
										</div>
										<div>
											<button
												class="dynvibeTranslateProfile dynvibeButton"
												@click="translatePost(post, $event)"
												style="margin-bottom: 0; margin-top: 5px"
											>
												Translate
											</button>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-12 dynvibeStoryText">
											<p>
												<span class="dynvibeToTranslateProfileResult" style="word-wrap: break-word">{{
													getPostTitle(post.post_content)
												}}</span>
												<span class="dynvibeToTranslateProfileResult" style="word-wrap: break-word">{{
													getPostDescription(post.post_content)
												}}</span>
											</p>
										</div>
										<div class="row">
											<span class="dynvibeTranslateResult"></span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="view == 'moodboard'">
				<div class="row dynvibeRow">
					<div class="dynvibeMoodboard">
						<div v-if="PostsWithPictures.length === 0" class="noData"><p>No Data to display</p></div>
						<div v-else>
							<ul class="dynvibeGalleryMedias">
								<li v-for="post in PostsWithPictures" class="filterMedia" :key="post._id">
									<!-- <span v-if="post.post_picture"> -->
									<a :href="post.post_url" v-if="post.post_picture" target="_blank" :style="getMediaStyle(post)">
										<span class="dynvibeGalleryMediasFilter"></span>
										<span class="dynvibeGalleryPopularMediasHover">
											{{ post.post_content }}
										</span>
									</a>
									<!-- </span> -->
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from "@/components/globalVue/Pagination.vue";

export default {
	name: "incomingposts",
	inject: ["picture_host"],
	props: {
		trendfilters: Object,
		semanticfilters: Object,
		mainkeyword: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {
					gte: "",
					lte: "",
				};
			},
		},
		country: {
			type: String,
			default: "",
		},
	},
	components: {
		pagination: pagination,
	},
	data() {
		return {
			view: "moodboard",
			posts: {},
			requests: {
				page: 0,
				pageMax: 0,
			},
			modalkeywords: "",
			nbPhotos: 10,
			PostsWithPictures: [],
		};
	},
	methods: {
		loadComponent(parameters = []) {
			let p = {
				parameters: { ...this.trendfilters, ...this.semanticfilters, mainkeyword: this.mainkeyword },
			};

			if (parameters.modalkeywords !== undefined) {
				if (this.modalkeywords !== parameters.modalkeywords) {
					// new word added, reset page to 0
					this.requests.page = 0;
				}
				this.modalkeywords = parameters.modalkeywords;
			}

			p.parameters.page = isNaN(this.requests.page) ? 0 : this.requests.page;

			p.parameters.modalkeywords = this.modalkeywords;
			p.parameters.level = this.level;
			p.parameters.view = this.view;
			p.parameters.nbPhotos = this.nbPhotos;

			if (this.date.gte != "") {
				p.parameters.date = this.date;
			}
			if (this.country != "") {
				p.parameters.country = [this.country];
			}
			this.getData("incomingPosts", p);
		},
		getOnlyPostsWithPictures() {
			let filtredPosts = this.posts.filter((e) => e.post_picture != "");
			if (filtredPosts.length == 0) {
				this.view = "posts";
			}
			return filtredPosts;
		},
		treatResponse(response) {
			this.requests.page = parseInt(response.data.page);
			this.requests.pageMax = parseInt(response.data.pageMax);
			this.posts = [];
			for (let i = 0; i < response.data.posts.length; i++) {
				this.posts.push(response.data.posts[i]._source);
			}
			this.PostsWithPictures = this.getOnlyPostsWithPictures();
			if (this.PostsWithPictures.length == 0) {
				this.view = "posts";
			}
		},
		changeNbPhotos() {
			this.loadComponent();
		},
		changePostPage(page) {
			this.requests.page = page;
			this.loadComponent();
		},
		getPostDate(date) {
			return new Date(date).toISOString().substr(0, 19).replace("T", " ");
		},
		getPostTitle(content) {
			let removeDelim = content.split("ebivnyd");
			return removeDelim[0];
		},
		getPostDescription(content) {
			let removeDelim = content.split("ebivnyd");
			if (typeof removeDelim[1] !== "undefined") return removeDelim[1];
			else return "";
		},
		getMediaPicture(media, url, profile_id) {
			let mediaPicture = "";
			if (media === "twitter") {
				mediaPicture = mediaPicture.replace("_normal.", "_400x400");
				mediaPicture = mediaPicture.replace("size=bigger", "size=original");
			} else if (media === "instagram") {
				let shortcode = url.split("/")[4];
				return [mediaPicture, this.picture_host + profile_id + "/source/" + shortcode + ".jpg"];
			}
			return mediaPicture;
		},

		postImage(post) {
			//let v = media == 'instagram' ? url + 'media/?size=m' : picture*
			let photo = this.getMediaPicture(post["post_media"], post["post_url"], post["profile_id"]);
			if (Array.isArray(photo)) {
				return "background-image:url(" + post["post_picture"] + "),url(" + photo[1] + ");";
			} else {
				return "background-image:url(" + photo + ");";
			}
		},
		translatePost(post, e) {
			let target = e.target.closest(".dynvibeStoryContenu").querySelector("span.dynvibeTranslateResult");

			if (target.style.display == "block") {
				target.style.display = "none";
			} else {
				let textToTranslate = this.getPostTitle(post.post_content) + this.getPostDescription(post.post_content);
				let p = {
					textToTranslate: {
						title: textToTranslate,
					},
				};
				this.$axios
					.get(this.$backendUrl + "translate", {
						params: p,
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, { arrayFormat: "brackets" });
						},
					})
					.then((response) => {
						target.innerHTML = response.data.data.textTranslate;
						target.style.display = "block";
					});
			}
		},
		// post.post_media, post.post_url, post.post_picture
		getMediaStyle(post) {
			// media = "https://source.unsplash.com/random/180x180?sig=" + Math.floor(Math.random() * 100);
			let mediaPicture = post["post_picture"];
			if (post["post_media"] === "twitter") {
				mediaPicture = mediaPicture.replace("_normal.", "_400x400");
				mediaPicture = mediaPicture.replace("size=bigger", "size=original");
			} else if (post["post_media"] === "instagram") {
				let shortcode = post["post_url"].split("/")[4];
				mediaPicture = this.picture_host + post["profile_id"] + "/source/" + shortcode + ".jpg";
			}

			return (
				"background-image:url(" +
				mediaPicture +
				");width: 150px;height: 150px;display: block;background-position: center;background-size: cover;"
			);
		},
	},
	watch: {
		view(newVal) {
			if (newVal == "posts" || (newVal == "moodboard" && parseInt(this.nbPhotos) > 10)) this.$emit("expandposts", true);
			else this.$emit("expandposts", false);
		},
		nbPhotos(newVal) {
			if (this.view == "moodboard" && parseInt(newVal) > 10) this.$emit("expandposts", true);
			else this.$emit("expandposts", false);
		},
	},
};
</script>

<style scoped>
div.dynvibeStoryImg a {
	width: 60px;
	height: 60px;
	margin-left: 10px;
	margin-top: 12px;
	padding: 0;
	max-width: 100%;
	display: block;
	background-position: center;
	background-size: cover;
}

.filterMedia {
	float: left;
	list-style: none;
	position: relative;
	width: auto;
	margin-right: 15px;
	margin-bottom: 10px;
	margin: 5px;
}

.dynvibeGalleryMedias {
	list-style: none;
}

.dynvibeGalleryMedias > li {
	display: inline-block;
}

.dynvibeGalleryMediasFilter {
	position: absolute;
	top: 0;
	width: auto;
	height: auto;
	display: none;
	background-color: rgba(35, 5, 107, 0.5);
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryMediasFilter,
.imageSlider:hover .dynvibeGalleryMediasFilter {
	display: block;
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryPopularMediasHover,
.imageSlider:hover .dynvibeGalleryPopularMediasHover {
	display: block;
}

.dynvibeGalleryPopularMediasHover {
	display: none;
	position: absolute;
	top: 5%;
	width: 100%;
	text-align: center;
	text-transform: initial;
	color: #33d1cd;
	font-weight: 700;
	font-size: 12px;
	max-height: 95%;
	overflow: hidden;
}

label {
	display: inline-block;
	margin-left: 6px;
	margin-right: 30px;
}

.dynvibeListPosts,
.dynvibeMoodboard {
	height: 100%;
}

.dynvibeToTranslateProfileResult {
	font-family: "Montserrat";
	color: #333;
	font-size: 13px;
	font-weight: 400;
}

.dynvibeGalleryMediasFilter {
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	display: none;
	background-color: rgba(35, 5, 107, 0.5);
}

.dynvibeStoryContenu {
	padding: 10px 0 25px 0px;
	border-bottom: 1px solid #e6e6e6;
}
</style>
